module.exports = __webpack_public_path__ + "static/media/baseline-clear-24px.777b93c6.svg";